import { createContext } from '@lyearn/core/utils/context';
import { ProviderType } from '@/types/schema';

import { ActionItemFragment } from '../graphql/fragments/generated/ActionItem';
import type useActionItemActions from '../hooks/useActionItemActions';

interface ActionItemContextValue {
  actionItem: ActionItemFragment & { showParentName?: boolean };
  actions?: ReturnType<typeof useActionItemActions>['actions'];
  provider?: ProviderType;
  isReadOnly?: boolean;
  disableInteractiveTooltip?: boolean;
}

export const [ActionItemProvider, useActionItemContext] =
  createContext<ActionItemContextValue>('ActionItem');
